import { render, staticRenderFns } from "./LogoutButton.vue?vue&type=template&id=6c3e3dad"
import script from "./LogoutButton.vue?vue&type=script&lang=js"
export * from "./LogoutButton.vue?vue&type=script&lang=js"
import style0 from "./LogoutButton.vue?vue&type=style&index=0&id=6c3e3dad&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports